export const Content1DataSource = {
  wrapper: { className: 'home-page-wrapper tool-content1-wrapper' },
  page: { className: 'home-page tool-content1' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.tool.platform'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'Toolchain'
      },
      {
        name: 'content',
        className: 'content',
        children: 'product.tool.introduce'
      },
    ],
  },
};

export const Content2DataSource = {
  wrapper: { className: 'home-page-wrapper tool-content2-wrapper' },
  page: { className: 'home-page tool-content2' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.tool.solution'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'SOLUTION'
      },
    ],
  },
  childWrapper: {
    className: 'tool-content2-block-wrapper',
    children: {
      name: 'block0',
      className: 'tool-content2-block',
      active: true,
      img: 'tool-01.png',
      children: {
        className: 'tool-content2-block-item',
        children: [
          {
            name: 'content',
            className: 'tool-content2-block-content',
            title: 'product.tool.solutionTitle01',
            children: 'product.tool.solutionContent01',
          }, {
            name: 'content',
            className: 'tool-content2-block-content',
            title: 'product.tool.solutionTitle02',
            children: 'product.tool.solutionContent02',
          }, {
            name: 'content',
            className: 'tool-content2-block-content',
            title: 'product.tool.solutionTitle03',
            children: 'product.tool.solutionContent03',
          }, {
            name: 'content',
            className: 'tool-content2-block-content',
            title: 'product.tool.solutionTitle04',
            children: 'product.tool.solutionContent04',
          },
        ]
      },
    },
  },
};

export const Content3DataSource = {
  wrapper: { className: 'home-page-wrapper tool-content3-wrapper' },
  page: { className: 'home-page tool-content3' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      { name: 'title', className: 'title-h1', children: 'product.tool.applicationScenario' },
      { name: 'sub-title', className: 'sub-title', children: 'APPLICATION SCENARIO' }
    ],
  },
  childWrapper: {
    className: 'tool-content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'tool-content3-block',
        active: true,
        children: {
          className: 'tool-content3-block-item',
          img: 'tool-03.png',
          title: 'product.tool.applicationScenarioTitle01',
          children: [
            {
              name: 'content',
              className: 'tool-content3-block-content',
              children: 'product.tool.applicationScenario01Content01',
            }, {
              name: 'content',
              className: 'tool-content3-block-content',
              children: 'product.tool.applicationScenario01Content02',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'tool-content3-block',
        active: true,
        children: {
          className: 'tool-content3-block-item',
          img: 'tool-04.png',
          title: 'product.tool.applicationScenarioTitle02',
          children: [
            {
              name: 'content',
              className: 'tool-content3-block-content',
              children: 'product.tool.applicationScenario02Content01',
            }, {
              name: 'content',
              className: 'tool-content3-block-content',
              children: 'product.tool.applicationScenario02Content02',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'tool-content3-block',
        active: true,
        children: {
          className: 'tool-content3-block-item',
          img: 'tool-05.png',
          title: 'product.tool.applicationScenarioTitle03',
          children: [
            {
              name: 'content',
              className: 'tool-content3-block-content',
              children: 'product.tool.applicationScenario03Content01',
            }, {
              name: 'content',
              className: 'tool-content3-block-content',
              children: 'product.tool.applicationScenario03Content02',
            }
          ],
        },
      },
      {
        name: 'block3',
        className: 'tool-content3-block',
        active: true,
        children: {
          className: 'tool-content3-block-item',
          img: 'tool-06.png',
          title: 'product.tool.applicationScenarioTitle04',
          children: [
            {
              name: 'content',
              className: 'tool-content3-block-content',
              children: 'product.tool.applicationScenario04Content01',
            }, {
              name: 'content',
              className: 'tool-content3-block-content',
              children: 'product.tool.applicationScenario04Content02',
            }
          ],
        },
      }
    ],
  },
};
